import React from "react"
import styled from "@emotion/styled"
import { StaticImage } from "gatsby-plugin-image"

import Downloads from "../downloads"
import Logo from "../../assets/logo.inline.svg"
import theme from "../../styles/theme"

const StaticImagePhone = () => (
  <StaticImage
    placeholder="blurred"
    width={160}
    src="../../images/index-hero-unit.png"
    alt=""
  />
)
const StaticImageSmallBrokenPhone = ({ className }) => (
  <StaticImage
    className={className}
    width={50}
    src="../../images/index-hero-unit-small-broken-phone.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallEcigarette = ({ className }) => (
  <StaticImage
    className={className}
    width={60}
    src="../../images/index-hero-unit-small-ecigarette.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallHairDryer = ({ className }) => (
  <StaticImage
    className={className}
    width={100}
    src="../../images/index-hero-unit-small-hair-dryer.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallShoes = ({ className }) => (
  <StaticImage
    className={className}
    width={70}
    src="../../images/index-hero-unit-small-shoes.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallSweater = ({ className }) => (
  <StaticImage
    className={className}
    width={60}
    src="../../images/index-hero-unit-small-sweater.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallTonerYellow = ({ className }) => (
  <StaticImage
    className={className}
    width={50}
    src="../../images/index-hero-unit-small-toner-yellow.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallVacuum = ({ className }) => (
  <StaticImage
    className={className}
    width={80}
    src="../../images/index-hero-unit-small-vacuum.png"
    alt=""
    placeholder="blurred"
  />
)
const StaticImageSmallJean = ({ className }) => (
  <StaticImage
    className={className}
    width={80}
    src="../../images/index-hero-unit-small-jean.png"
    alt=""
    placeholder="blurred"
  />
)

const StaticImageSmallEuro0 = ({ className }) => (
  <StaticImage
    className={className}
    width={15}
    src="../../images/index-hero-unit-small-euro.png"
    alt=""
    placeholder="blurred"
  />
)

const StaticImageSmallEuro1 = ({ className }) => (
  <StaticImage
    className={className}
    width={20}
    src="../../images/index-hero-unit-small-euro.png"
    alt=""
    placeholder="blurred"
  />
)

const StaticImageSmallEuro2 = ({ className }) => (
  <StaticImage
    className={className}
    width={25}
    src="../../images/index-hero-unit-small-euro.png"
    alt=""
    placeholder="blurred"
  />
)

const StaticImageSmallEuro3 = ({ className }) => (
  <StaticImage
    className={className}
    width={35}
    src="../../images/index-hero-unit-small-euro.png"
    alt=""
    placeholder="blurred"
  />
)

const HeroUnit = ({ className }) => {
  return (
    <section className={className}>
      <div className="inner grid grid-section grid_3-2">
        <StyledTitleWrapper>
          <StyledTitle className="h1 text-sm-center">
            <em>Tu recycles</em>
            <br />
            on te <em className="variant">récompense</em>
          </StyledTitle>
          <Downloads />
        </StyledTitleWrapper>

        <StyledWrapper>
          <StyledPhoneImageWrapper>
            <StyledStaticImageSmallEuro1 />
            <StyledStaticImageSmallEuro2 />
            <StyledStaticImageSmallEuro3 />
            <StyledStaticImageSmallEuro4 />
            <StyledStaticImageSmallEuro5 />
            <StyledStaticImageSmallEuro6 />
            <StyledStaticImageSmallBrokenPhone />
            <StyledStaticImageSmallEcigarette />
            <StyledStaticImageSmallHairDryer />
            <StyledStaticImageSmallShoes />
            <StyledStaticImageSmallSweater />
            <StyledStaticImageSmallTonerYellow />
            <StyledStaticImageSmallVacuum />
            <StyledStaticImageSmallJean />
            <StyledLogo />
            <StaticImagePhone />
          </StyledPhoneImageWrapper>
        </StyledWrapper>
      </div>
    </section>
  )
}

const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: ${theme.breakpoint.medium}px) {
    & {
      display: block;
    }
  }
`

const StyledTitle = styled.h2`
  margin-bottom: 2rem;
`

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const StyledPhoneImageWrapper = styled.div`
  margin-top: 300px;
  position: relative;
`

const StyledStaticImageSmallEuro1 = styled(StaticImageSmallEuro1)`
  position: absolute;
  right: -10px;
  top: -220px;
`

const StyledStaticImageSmallEuro2 = styled(StaticImageSmallEuro2)`
  position: absolute;
  left: 60px;
  top: -15px;
`
const StyledStaticImageSmallEuro3 = styled(StaticImageSmallEuro3)`
  position: absolute;
  right: 30px;
  top: -140px;
`
const StyledStaticImageSmallEuro4 = styled(StaticImageSmallEuro2)`
  position: absolute;
  left: 10px;
  top: -260px;
`

const StyledStaticImageSmallEuro5 = styled(StaticImageSmallEuro1)`
  position: absolute;
  left: 30px;
  top: -100px;
`

const StyledStaticImageSmallEuro6 = styled(StaticImageSmallEuro0)`
  position: absolute;
  left: -30px;
  top: -200px;
`

const StyledStaticImageSmallBrokenPhone = styled(StaticImageSmallBrokenPhone)`
  position: absolute;
  right: -80px;
  top: -250px;
`
const StyledStaticImageSmallEcigarette = styled(StaticImageSmallEcigarette)`
  position: absolute;
  right: -40px;
  top: -120px;
`
const StyledStaticImageSmallHairDryer = styled(StaticImageSmallHairDryer)`
  position: absolute;
  right: -25px;
  top: -190px;
`
const StyledStaticImageSmallShoes = styled(StaticImageSmallShoes)`
  position: absolute;
  left: -50px;
  top: -150px;
`
const StyledStaticImageSmallSweater = styled(StaticImageSmallSweater)`
  position: absolute;
  left: -80px;
  top: -260px;
`
const StyledStaticImageSmallTonerYellow = styled(StaticImageSmallTonerYellow)`
  position: absolute;
  left: 80px;
  top: -260px;
`
const StyledStaticImageSmallVacuum = styled(StaticImageSmallVacuum)`
  position: absolute;
  left: 30px;
  top: -100px;
`
const StyledStaticImageSmallJean = styled(StaticImageSmallJean)`
  position: absolute;
  lef: -30px;
  top: -220px;
`

const StyledLogo = styled(Logo)`
  z-index: 1;
  position: absolute;
  width: 80px;
  left: 40px;
  top: 30%;
`

export default HeroUnit
